import { tw } from '@/utils/tw';

/** Commented sections will be uncommented after Button refactoring */

// import { ButtonTheme } from '@/components/Button/theme';
// import { mapValues, transform } from 'lodash-es';

// const buttonVariants = mapValues(ButtonTheme.variants, (value) =>
//   mapValues(value, () => []),
// ) as (typeof ButtonTheme)['variants'];

// type ButtonCompoundVariant = {
//   [key: string]: string | string[] | boolean;
//   button: true;
//   cover: false;
//   class: string[];
// };

// const buttonCompoundVariants = transform(
//   ButtonTheme.variants,
//   (result, options, variant) => {
//     for (const option in options) {
//       result.push({
//         button: true,
//         cover: false,
//         [variant]: option === 'true' ? true : option === 'false' ? false : option,
//         class: options[option as keyof typeof options],
//       });
//     }
//   },
//   [] as ButtonCompoundVariant[],
// );

const Link = tw.theme({
  base: [],
  variants: {
    // button: {
    //   true: [],
    // },
    cover: {
      true: ['absolute', 'inset-0', 'z-1', 'flex', 'h-full', 'w-full', 'items-center', 'justify-center'],
    },
    // ...buttonVariants,
  },
  compoundVariants: [
    // {
    //   button: true,
    //   cover: false,
    //     class: ButtonTheme.base,
    // },
    // ...buttonCompoundVariants,
  ],
  defaultVariants: {
    // ...ButtonTheme.defaultVariants,
  },
});

export default Link;
